import { Cell, Row } from "@tanstack/react-table";
import { useEffect, useState } from "react";

import { useTableContext } from "../../context";

interface SelectOption {
  value: string | boolean;
  label: string;
}

export default function CellSelect<T>({
  row,
  cell,
  options,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
  options: SelectOption[];
}) {
  const { table } = useTableContext();

  const updateData = table?.options?.meta?.updateData;
  const isUpdating = table?.options?.meta?.isUpdating ?? false;
  const columnId = cell.column?.id;
  const cellValue = cell.getValue() as string | undefined;

  const [value, setValue] = useState(cellValue || "");

  useEffect(() => {
    setValue(cellValue || "");
  }, [cellValue]);

  return (
    <select
      value={value}
      onChange={(event) => {
        const newValue = event.target.value;
        setValue(newValue);
        updateData?.(row, columnId, newValue);
      }}
      disabled={isUpdating}
      className="w-full px-2 py-1 border border-gray-300 rounded-sm focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    >
      <option value="" disabled>
        Select an option...
      </option>
      {options.map((option) => (
        <option key={option.value.toString()} value={option.value.toString()}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
